import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { downloadCurrentUserFeatureUsage } from "state/usage/operations";
import { useFeatureUsage } from "./useFeatureUsage";
import type { FeatureUsage } from "api/usage/models/FeatureUsage";

export const useFeatureUsageWithFetch = (handle: string): FeatureUsage | undefined => {
  const dispatch = useDispatch();
  const usage = useFeatureUsage(handle);

  useEffect(() => {
    dispatch(downloadCurrentUserFeatureUsage());
  }, [dispatch]);

  return usage;
};
